module.exports = __webpack_public_path__ + "static/img/macdb.c84d783.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/macdb.png
// module id = HS3h
// module chunks = 1